import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './Icon.module.css';

import '../../../libs/fontawesome6pro/css/all.min.css';
import '../../../libs/fontawesome6pro/css/light.min.css';
import '../../../libs/fontawesome6pro/css/regular.min.css';
import '../../../libs/fontawesome6pro/css/solid.min.css';

export enum IconSize {
  Small = 'small',
  Normal = 'normal',
  Large = 'large'
}
export enum IconType {
  Light = 'light',
  Regular = 'regular',
  Solid = 'solid'
}

export type IconProps = ComponentProps<'i'> & {
  size?: IconSize;
  type?: IconType;
  hasTextOnLeftSide?: boolean;
  hasTextOnRightSide?: boolean;
  /**
   * icon name without prefix, e.g. trash, times ...
   */
  name: string;
};

export const Icon: FunctionComponent<IconProps> = React.memo((props) => {
  const {
    className,
    hasTextOnLeftSide = false,
    hasTextOnRightSide = false,
    size = IconSize.Normal,
    type = IconType.Regular,
    name,
    ...remainingProps
  } = prepareProps({ props, ignoreChildren: true });

  return (
    <i
      {...remainingProps}
      className={classes(
        className,
        styles.general,
        iconSizeToClassName[size],
        iconTypeToClassName[type],
        `fa-${name}`,
        hasTextOnLeftSide ? styles.textOnLeftSide : undefined,
        hasTextOnRightSide ? styles.textOnRightSide : undefined
      )}
    ></i>
  );
});

const iconSizeToClassName: Record<IconSize, string> = {
  small: styles.sizeSmall,
  normal: styles.sizeNormal,
  large: styles.sizeLarge
};

const iconTypeToClassName: Record<IconType, string> = {
  regular: 'far',
  light: 'fal',
  solid: 'fas'
};
